import { all, fork, takeLatest } from 'redux-saga/effects';

import {
    EXECUTE_ASSIGNMENT_ACTION,
    GET_BOARD_POLICIES,
    GET_BORDEREAU_DOWNLOAD_URL,
    GET_BORDEREAU_SUMMARIES,
    GET_BOUND_POLICIES,
    GET_LIST_POLICIES,
    GET_TRIAGE_POLICIES,
    QUERY_BOUND_POLICIES,
    QUERY_POLICIES,
    QUERY_TRIAGE_POLICIES,
} from '../../constants/actions/policies';
import { executeAssignmentActionSaga } from './executeAssignmentActionSaga';
import { getBoardPoliciesSaga } from './getBoardPoliciesSaga';
import { getBordereauDownloadUrlSaga } from './getBordereauDownloadUrlSaga';
import { getBordereauSummariesSaga } from './getBordereauSummariesSaga';
import { getBoundPoliciesSaga } from './getBoundPoliciesSaga';
import { getListPoliciesSaga } from './getListPoliciesSaga';
import { getTriagePoliciesSaga } from './getTriagePoliciesSaga';
import { queryBoundPoliciesSaga } from './queryBoundPoliciesSaga';
import { queryPoliciesSaga } from './queryPoliciesSaga';
import { queryTriagePoliciesSaga } from './queryTriagePoliciesSaga';

function* watchGetBoundPolicies() {
    yield takeLatest(GET_BOUND_POLICIES, getBoundPoliciesSaga);
}

function* watchGetListPolicies() {
    yield takeLatest(GET_LIST_POLICIES, getListPoliciesSaga);
}

function* watchQueryPolicies() {
    yield takeLatest(QUERY_POLICIES, queryPoliciesSaga);
}

function* watchGetTriagePolicies() {
    yield takeLatest(GET_TRIAGE_POLICIES, getTriagePoliciesSaga);
}

function* watchQueryTriagePolicies() {
    yield takeLatest(QUERY_TRIAGE_POLICIES, queryTriagePoliciesSaga);
}

function* watchExecuteAssignmentAction() {
    yield takeLatest(EXECUTE_ASSIGNMENT_ACTION, executeAssignmentActionSaga);
}

function* watchQueryBoundPolicies() {
    yield takeLatest(QUERY_BOUND_POLICIES, queryBoundPoliciesSaga);
}

function* watchGetBoardPolicies() {
    yield takeLatest(GET_BOARD_POLICIES, getBoardPoliciesSaga);
}

function* watchGetBordereauSummaries() {
    yield takeLatest(GET_BORDEREAU_SUMMARIES, getBordereauSummariesSaga);
}

function* watchGetBordereauDownloadUrl() {
    yield takeLatest(GET_BORDEREAU_DOWNLOAD_URL, getBordereauDownloadUrlSaga);
}

function* root() {
    return yield all([
        fork(watchGetBoundPolicies),
        fork(watchGetListPolicies),
        fork(watchQueryPolicies),
        fork(watchGetTriagePolicies),
        fork(watchQueryTriagePolicies),
        fork(watchExecuteAssignmentAction),
        fork(watchQueryBoundPolicies),
        fork(watchGetBoardPolicies),
        fork(watchGetBordereauSummaries),
        fork(watchGetBordereauDownloadUrl),
    ]);
}

export default root;
